import http from '../http.js'

export class RoleService {
  static getRoles () {
    return http.get('/roles')
  }
}
